import React from 'react';
import Table from 'components/shared/table';
import DateFormat from 'constants/date_format';

const ArchivesDateCell = ({ archivedAt }) => {
  const date = archivedAt ? moment(archivedAt) : null;
  return (
    <Table.BodyCell size="s" hideBelowMD>
      {date ? date.format(DateFormat.LONG_AT_TIME) : '-'}
    </Table.BodyCell>
  );
};

export default ArchivesDateCell;
